import { ASSETS } from "@/lib/brand";
import SectionHeading from "@/components/shared/SectionHeading";

export default function AboutSection() {
  return (
    <section
      data-testid="home-about"
      className="section-pad bg-beige/60 relative overflow-hidden"
    >
      <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Left: multi-portrait collage */}
        <div className="lg:col-span-6 relative reveal">
          <div className="relative aspect-[4/5] bg-cream">
            <img
              src={ASSETS.portraits.about}
              alt="Kiap Yong"
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-beige/30 to-transparent" />
          </div>
          <div className="hidden md:block absolute -bottom-10 -right-6 w-1/2 aspect-[3/4] border-8 border-beige overflow-hidden bg-cream shadow-xl">
            <img
              src={ASSETS.portraits.formal}
              alt="Kiap Yong formal portrait"
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute -top-4 -left-4 h-24 w-24 border-l border-t border-bronze hidden md:block" />
        </div>

        {/* Right: story */}
        <div className="lg:col-span-6 lg:pl-10">
          <SectionHeading
            eyebrow="Founder of A Homely Abode"
            title={<>Hi, I'm <span className="italic text-bronze">Kiap Yong</span>.</>}
          />

          <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed font-light text-ink_soft/85">
            <p>
              I believe your property shouldn't just be a home — it should be part of your financial
              future. Property is one of the most powerful tools to build long-term wealth.
            </p>
            <p>
              With a strong focus on strategic upgrading and estate portfolio planning, I empower
              homeowners to grow their wealth through smart, well-timed property moves.
            </p>
            <p>
              From first-time buyers to seasoned investors, I provide the insights and strategies you
              need to succeed. My approach combines market analysis, financial planning, and
              personalised service to ensure every investment aligns with your goals.
            </p>
            <p className="font-serif italic text-2xl text-bronze leading-snug">
              I've always delivered with patience and integrity. Let's turn your property ambitions
              into reality.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
